import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { BootstrapVue, IconsPlugin, BTable } from 'bootstrap-vue';
//import Mgr from "./service/AuthenticationService";
import axios from 'axios';
import EventBus from './utils/EventBus';

import { getLightnessFromHex, hexToLightTint } from './utils/colors';
import Constants from '@/utils/Constants';
import ResizableColumns from './directives/resizableColumns.mjs';

const utils = require('./utils/formatting.js');

// Import Bootstrap an BootstrapVue CSS files (order is important)
import './scss/style.scss';

//import Donut from 'vue-css-donut-chart';
//import 'vue-css-donut-chart/dist/vcdonut.css';
//Vue.use(Donut);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// bootstrap-vue hardcodes the English empty-text defaults, so override them globally to German.
BTable.options.props.emptyText.default = 'Keine Einträge vorhanden';
BTable.options.props.emptyFilteredText.default = 'Keine Einträge für den aktuellen Filter gefunden';
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// Global directive to make table columns resizable by dragging their border
Vue.directive('resizable-columns', ResizableColumns);

Vue.prototype.CONSTANTS = require('./utils/Constants.js');
Vue.prototype.$axios = axios;
Vue.prototype.$utils = utils;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.console = console;
Vue.prototype.window = window;

import { Auth0Plugin } from './auth';

Vue.use(Auth0Plugin, {
  domain: 'dev-tbfxeymi.eu.auth0.com',
  clientId: '5h6zAA7xz2JviuuRqO69E1p3h2DaQoo1',
  audience: 'https://192.168.178.122:8081/api',
  redirect_uri: window.location.origin,
  authorizationParams: {
    redirect_uri: window.location.origin
  },
  onRedirectCallback: appState => {
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  }
});

Vue.config.productionTip = false;

var lightSchemeIcon = document.querySelector('link#light-scheme-icon');
var darkSchemeIcon = document.querySelector('link#dark-scheme-icon');
var matcher = window.matchMedia('(prefers-color-scheme: dark)');

matcher.addListener(onUpdate);
onUpdate();

function onUpdate() {
  if (matcher.matches) {
    lightSchemeIcon.remove();
    document.head.append(darkSchemeIcon);
  } else {
    document.head.append(lightSchemeIcon);
    darkSchemeIcon.remove();
  }
}

Vue.prototype.$showError = (context, error, title = 'Fehler') => {
  console.log('DISPLAYED ERROR:', error);
  context.$bvToast.toast(error, {
    title,
    variant: 'danger',
    solid: true,
    toaster: 'b-toaster-bottom-right'
  });
};
Vue.prototype.$showWarning = (context, warning, title = 'Warnung') => {
  console.warn('DISPLAYED WARNING:', warning);
  context.$bvToast.toast(warning, {
    title: title,
    variant: 'warning',
    solid: true,
    toaster: 'b-toaster-bottom-right'
  });
};
Vue.prototype.$showSuccess = (context, title, info, toaster = 'b-toaster-bottom-right') => {
  context.$bvToast.toast(info, {
    title: title,
    variant: 'success',
    solid: true,
    toaster
  });
};
Vue.prototype.$handleError = err => {
  if (err.response) this.$showError(this, err.response.data);
  else this.$showError(this, err.toString());
};

Vue.prototype.applyCustomTheme = async theme => {
  if (!theme || !theme.primaryColor) return;

  var color = theme.primaryColor;
  //AppState.customPrimaryColor = color;

  const colorLightness = getLightnessFromHex(color);

  var styleId = 'bv-bg-primary-theme';
  var styleTag = document.getElementById(styleId);
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = styleId;
    document.head.appendChild(styleTag);
  }

  document.documentElement.style.setProperty('--bauvisor-primary', color);
  document.documentElement.style.setProperty('--bauvisor-primary-light', hexToLightTint(color, 0.98));
  document.documentElement.style.setProperty('--bauvisor-primary-light-semi', hexToLightTint(color, 0.96));
  document.documentElement.style.setProperty('--bauvisor-primary-semi-light', hexToLightTint(color, 0.96));
  document.documentElement.style.setProperty('--bauvisor-primary-light-semi-2', hexToLightTint(color, 0.94));
  document.documentElement.style.setProperty('--bauvisor-primary-light-semi-3', hexToLightTint(color, 0.92));

  styleTag.textContent = `.bg-primary { background-color: var(--bauvisor-primary) !important;  } .badge-primary { background-color: var(--bauvisor-primary) !important; } .text-primary { color: var(--bauvisor-primary) !important; } .table-wrapper tbody tr:hover td.sticky-col { background-color: var(--bauvisor-primary-light-semi) !important; }`;

  // if colorLightness > x, we need to switch primary text color to dark grey
  // Note: append (+=) so the .bg-primary override above is preserved instead of overwritten
  if (colorLightness > Constants.THEME_LIGHTNESS_THRESHOLD) {
    //console.log('Color is light, switching primary text color to dark grey');
    document.documentElement.style.setProperty('--bauvisor-primary-text-color', '#333333');
    styleTag.textContent += `.main-nav-active, .main-nav-active:hover { color: #333333 !important;}`;
  } else {
    document.documentElement.style.setProperty('--bauvisor-primary-text-color', '#ffffff');
    styleTag.textContent += `.main-nav-active, .main-nav-active:hover { color: #ffffff !important;}`;
  }

  // bv-logo-bw-header-inv.svg
  // if a custom theme is applied, we also need to replace the logo in the header with a black and white version to make sure it is visible on the colored background. this is done by replacing the image source of all images with id "main-logo" to "bv-logo-bw-header-inv.svg"
  var logoImages = document.querySelectorAll('#main-logo');

  logoImages.forEach(img => {
    img.src = require('@/assets/bv-logo-bw-header-inv.svg');
  });
};

Vue.prototype.resetThemeToDefault = () => {
  document.documentElement.style.setProperty('--bauvisor-primary', null);
  document.documentElement.style.setProperty('--bauvisor-primary-light', null);
  document.documentElement.style.setProperty('--bauvisor-primary-light-semi', null);
  document.documentElement.style.setProperty('--bauvisor-primary-semi-light', null);
  document.documentElement.style.setProperty('--bauvisor-primary-text-color', null);
  var logoImages = document.querySelectorAll('#main-logo');

  logoImages.forEach(img => {
    img.src = require('@/assets/bv-logo.svg');
  });
};

Vue.prototype.sortTableItemsBy = (items, field, direction = 'asc', type = null) => {
  //console.log('sorting field', field, ' order ', direction, type);
  items.sort((a, b) => {
    if (type == 'number') {
      a = parseFloat(a[field]);
      b = parseFloat(b[field]);
      if (direction == 'asc') {
        return b - a;
      } else {
        return a - b;
      }
    } else {
      if (a[field] == null) return 1;
      if (b[field] == null) return -1;
      // Natural sort so alphanumeric values order like 1, 2, 10 (matches BootstrapVue default)
      if (direction == 'asc') {
        return a[field].toLowerCase().localeCompare(b[field].toLowerCase(), undefined, { numeric: true });
      } else {
        return b[field].toLowerCase().localeCompare(a[field].toLowerCase(), undefined, { numeric: true });
      }
    }
  });
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
